import { Trans, useTranslation } from "react-i18next";
import { Radio } from "@components/inputs/Radio/Radio";
import { Link } from "@components/Link/Link";
import { useApiErrorUtils } from "@hooks/useApiErrorUtils";
import { useUpdatePaymentTaxCollectorTypeMutation } from "@services/payments/mutations";
import {
  TaxCollectorTypeId,
  type IPaymentTaxCollectorTypes,
  type ITaxCollectorType,
} from "@services/payments/types";

interface ITaxCollectorRadioProps {
  paymentTaxCollectorData?: IPaymentTaxCollectorTypes;
  currentPaymentTaxCollector?: ITaxCollectorType;
}

export const TaxCollectorRadio: React.FC<ITaxCollectorRadioProps> = (props) => {
  const { paymentTaxCollectorData, currentPaymentTaxCollector } = props;
  const { t } = useTranslation();

  const { mutateAsync: updatePaymentTaxCollectorType } =
    useUpdatePaymentTaxCollectorTypeMutation();

  const options = paymentTaxCollectorData?.taxCollectorTypes
    .map((taxCollectorType) => ({
      label: taxCollectorType.name,
      value: taxCollectorType.taxCollectorTypeId,
      renderElement: (
        <Trans
          i18nKey={`billsPayment.taxCollectors.${taxCollectorType.taxCollectorTypeId}.name`}
          components={{
            href: (
              <Link
                to={t(
                  `billsPayment.taxCollectors.${taxCollectorType.taxCollectorTypeId}.link`,
                )}
                target="__blank"
              />
            ),
          }}
        />
      ),
    }))
    .sort((a) => (a.value === TaxCollectorTypeId.TARKPAY ? -1 : 1));

  const { toastApiError } = useApiErrorUtils();

  const changeTaxCollector = async (taxCollectorTypeId: TaxCollectorTypeId) => {
    await updatePaymentTaxCollectorType(taxCollectorTypeId).catch(
      toastApiError,
    );
  };

  return (
    <Radio
      name="TaxCollectorRadio"
      defaultValue={currentPaymentTaxCollector?.taxCollectorTypeId}
      onRadioOptionChange={(value) =>
        changeTaxCollector(value as TaxCollectorTypeId)
      }
      options={options ?? []}
    />
  );
};
